import script from "./switchEquipment.vue?vue&type=script&setup=true&lang=js"
export * from "./switchEquipment.vue?vue&type=script&setup=true&lang=js"

import "./switchEquipment.vue?vue&type=style&index=0&id=558c30ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558c30ea"]])

export default __exports__